// ROOK COFFEE — Locations Map
// Upload to: Assets/locations-map.js
// Geocodes addresses automatically using OpenStreetMap's free Nominatim service.
// Results are cached in localStorage so repeat visits don't re-geocode.

function lpInitMap() {
  var mapEl = document.querySelector('[id^="lp-map-"]');
  if (!mapEl) return;
  if (typeof L === 'undefined') { setTimeout(lpInitMap, 150); return; }
  if (mapEl.dataset.mapReady) return;

  var locations = [];
  try {
    locations = JSON.parse(mapEl.dataset.locations || '[]');
  } catch (e) {
    console.error('Rook locations map: could not parse location data', e);
    return;
  }

  if (locations.length === 0) return;

  mapEl.dataset.mapReady = '1';
  var accent = mapEl.dataset.accent || '#c5603a';

  var map = L.map(mapEl, { scrollWheelZoom: false });
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 18
  }).addTo(map);

  var markerIcon = L.divIcon({
    className: 'lp-marker',
    html: '<div style="width:28px;height:28px;background:' + accent + ';border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.3);"><div style="width:10px;height:10px;background:#fbf5ed;border-radius:50%;transform:rotate(45deg);"></div></div>',
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -28]
  });

  // Default view while geocoding — centered on NJ shore area
  map.setView([40.28, -74.05], 10);

  var CACHE_KEY = 'rook_geocode_cache_v1';
  var cache = {};
  try {
    cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
  } catch (e) { cache = {}; }

  var bounds = [];
  var geocodeQueue = locations.slice();

  function addMarker(loc, lat, lng) {
    var marker = L.marker([lat, lng], { icon: markerIcon }).addTo(map);
    var popupHtml = '<div class="lp-popup-name">' + loc.name + '</div>'
      + '<div class="lp-popup-addr">' + loc.addr1 + (loc.addr2 ? ', ' + loc.addr2 : '') + '<br>' + loc.cityState + '</div>'
      + '<a class="lp-popup-link" href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(loc.fullAddr) + '" target="_blank" rel="noopener">Get Directions &rarr;</a>';
    marker.bindPopup(popupHtml);
    bounds.push([lat, lng]);
    if (bounds.length > 1) {
      map.fitBounds(bounds, { padding: [30, 30] });
    } else if (bounds.length === 1) {
      map.setView([lat, lng], 13);
    }
  }

  function geocodeNext() {
    if (geocodeQueue.length === 0) {
      setTimeout(function() { map.invalidateSize(); }, 200);
      return;
    }
    var loc = geocodeQueue.shift();
    var cacheKey = loc.fullAddr.toLowerCase().trim();

    if (cache[cacheKey]) {
      addMarker(loc, cache[cacheKey].lat, cache[cacheKey].lng);
      geocodeNext();
      return;
    }

    var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(loc.fullAddr);

    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data && data.length > 0) {
          var lat = parseFloat(data[0].lat);
          var lng = parseFloat(data[0].lon);
          cache[cacheKey] = { lat: lat, lng: lng };
          try { localStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
          addMarker(loc, lat, lng);
        } else {
          console.warn('Rook locations map: could not geocode', loc.fullAddr);
        }
      })
      .catch(function(err) {
        console.error('Rook locations map: geocoding error for', loc.fullAddr, err);
      })
      .finally(function() {
        // Nominatim usage policy: max 1 request/second
        setTimeout(geocodeNext, 1100);
      });
  }

  geocodeNext();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lpInitMap);
} else {
  lpInitMap();
}
